// ============================================================================
// Client portal route paths — one source of truth, shared by the router, the
// guard, and the nav. Kept separate from the trainer /app/* tree.
//   /client/claim   public  — claim an invite (reads ?token=) and set a password
//   /me/login       public  — client sign-in
//   /me             guarded  — portal home / dashboard (RequireClientAuth)
//   /me/log         guarded  — self-log (measurement + workout)
//   /me/report      guarded  — full progress report
// The backend mints the claim link as /client/claim?token=… so that path is
// fixed; everything else lives under /me to read clearly ("my" portal).
// ============================================================================
export const CLIENT_CLAIM_PATH = "/client/claim";
export const CLIENT_LOGIN_PATH = "/me/login";
// Wave 8 — self-service password recovery (PUBLIC). The forgot screen requests a
// reset link; the reset screen consumes the emailed token. The backend mints the
// reset link as /client/reset?token=… (a root path, NOT under /me) so it reads
// like the existing /client/claim invite link, hence the asymmetry below.
export const CLIENT_FORGOT_PATH = "/me/forgot";
export const CLIENT_RESET_PATH = "/client/reset";
export const CLIENT_HOME_PATH = "/me";
export const CLIENT_LOG_PATH = "/me/log";
export const CLIENT_CALENDAR_PATH = "/me/calendar";
export const CLIENT_MESSAGES_PATH = "/me/messages";
export const CLIENT_REPORT_PATH = "/me/report";
// Wave 8 — the client's own settings (change password + sign out), guarded.
export const CLIENT_ACCOUNT_PATH = "/me/account";
